export default {
      id: "i-view-tabular-usage",
      viewBox: "0 0 26 25",
      url: __webpack_public_path__ + "img/sprite.svg#i-view-tabular",
      toString: function () {
        return this.url;
      }
    }